export default "__VITE_ASSET__l0HXWi$B__"